


export default class IMStorage {

    static get(uid, key) {
        let obj = window.localStorage.getItem(uid + '_' + key);
        try {
            let js = JSON.parse(obj);
            return js;
        } catch (error) {
            console.log('IMStorage', error);
        }
        return null;
    }

    static set(uid, key, val) {
        return window.localStorage.setItem(uid + '_' + key, JSON.stringify(val));
    }

    static setItem(key, val) {
        window.localStorage.setItem(key, val);
    }

    static getItem(key) {
        return window.localStorage.getItem(key);
    }
}